import { BaseRepository } from "@/repositories/base-repository"
import type { IRentalDispenseMaterialization } from "@/interfaces/api/rental-dispense-materialization.interface"

export class RentalDispenseMaterializationRepository extends BaseRepository<IRentalDispenseMaterialization> {
  protected resourcePath = "administration/rental-dispense-materializations"
}
